const throttle = (fn, limit) => {
	let lastCall = 0;
	return (...args) => {
		const now = Date.now();
		if (now - lastCall >= limit) {
			lastCall = now;
			fn(...args);
		}
	};
};

export default throttle;
